import * as types from './types'

const intitialState = {
    histories: [],
    condFilters: {}
}

const compareFilterHistoryReducer = (state = intitialState, action) => {
    switch (action.type) {        
        case types.COMPARE_FILTER_HISTORY: {
            const { histories, ...payload } = action.payload
            return {
                ...state,
                ...payload,
                // histories: [...state.histories, ...histories],
                histories
            }
        }
        case types.COMPARE_FILTER_HISTORY_ERR: {
            return intitialState
        } 
        case types.RESET_COMPARE_FILTER_HISTORY: {
            return intitialState
        }     
        default:
            return state;
    }

}

export default compareFilterHistoryReducer